<div id="addEventPopup">
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 addEvents_header">
        <img src="../../../../assets/icons/Info Circle.png" alt="" (click)="closeModal()" style="cursor: pointer;"/>
      </div>
      <div class="addEventContainer">

        <div class="addeve-sty col-md-12 col-sm-12 col-xs-12 col-lg-12" style="margin-bottom: 10px;">Add events
        </div>

        <!-- <app-add-event-popup></app-add-event-popup> -->
        <form [formGroup]="eventForm">
          <div>
            <mat-form-field appearance="fill" style="height: 68px;">
              <input matInput type="text" value="" placeholder="Enter event title" maxlength="30"
                formControlName="title" />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="fill" class="datepicker">
              <input matInput readonly [matDatepicker]="dp" formControlName="date" [min]="todayDate"
                placeholder="Order pickup/delivery date" (click)="dp.open()"  style="cursor: pointer;"/>
              <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
              <mat-datepicker (closed)="onClosed()"  #dp></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="enterdeliveryteam desktop-time">
            <!-- <mat-form-field appearance="fill">

              <input matInput type="time" value="22:15:00" placeholder="Enter delivery time" formControlName="delivary" /> -->
            <!-- <span matSuffix><img src="../../../../assets/icons/clock-hour-3.png" /></span> -->
            <!-- </mat-form-field> -->
            <!-- <mat-form-field > -->
            <!-- <input matTimepicker #t="matTimepicker" #time="ngModel"
             id="myTime" mode="24h" [ngModel]="currentTime"
            placeholder="Please select time..." name="time" required
            (timeChange)="onTimeChange()"> -->
            <!-- <mat-label>Time</mat-label> -->
            <!-- </mat-form-field> -->
            <!-- <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="default" readonly>
            <ngx-material-timepicker #default></ngx-material-timepicker> -->

             <!-- <mat-label>Time</mat-label> -->

             <!-- formControlName="delivary" -->
            <input type="time" id="myTime" (change)="onTimeChange($event)" [value]="currentTime" >
             

            <!-- <mat-form-field appearance="fill">
              <input matTimepicker #t1="matTimepicker" okLabel="Ok"
                 cancelLabel="Cancel" 
                 id="myTime" mode="12h" color="accent" anteMeridiemAbbreviation="AM" postMeridiemAbbreviation='PM' class="org-timepicker" placeholder="Order pickup/delivery time"
                name="time-1" (timeChange)="onTimeChange($event)" [value]="currentTime" formControlName="delivary" required readonly style="cursor: pointer;">
              <mat-icon matSuffix (click)="t1.showDialog()" style="    display: inline-flex;
              justify-content: center;
              align-items: center;
              font-size: inherit;
              width: 2.5em;
              height: 2.5em;cursor: pointer;vertical-align: sub !important;"><img src="../../../../assets/icons/clock-hour-3.png" /></mat-icon>
            </mat-form-field> -->
            
          </div>

          <div class="select-team">Select teams</div>
          <div class="teamListCss" *ngIf="teamList?.length==0">
            <h3 style="font-size: 20px !important; margin-top: 15px;margin-bottom: 20px;">No Teams Found.</h3>
          </div>
          <span class="teamListCss" *ngIf="teamList?.length>0">
            <div class="gry-col" *ngFor="let val of teamList">
              <div class="gry_content">
                <div class="">
                  <img *ngIf="val?.logo" [src]="val.logo" alt="" height="50px" width="50px" />
                  <img *ngIf="!val?.logo" src="assets/icon/add-team.png" alt="" height="50px" width="50px" />
                </div>

                <div class=" royal-text">{{val.name}}</div>
                <div class="check-box" id="check_box_styl">

                  <!-- <input style="width: 20px; background: red; border: 1px solid red;cursor: pointer;" type="checkbox"
                    [checked]="val?.selected" (change)="selectTeams($event,val._id)" /> -->
                  <mat-checkbox class="example-margin" [checked]="val?.selected" (change)="selectTeams($event,val._id)"></mat-checkbox>
                  <!-- <img id="image{{val?._id}}" class="tickimg" (click)="onchangecolor(val._id)"
                    src="../../../../assets/icons/Vector.png"> -->
                </div>
              </div>
            </div>
          </span>

          <div>
            <mat-form-field appearance="fill">
              <input matInput type="text" value="" placeholder="Comments" formControlName="comment" />
            </mat-form-field>
          </div>

          <div>
            <button mat-raised-button color="warn" [disabled]="eventForm.invalid || !eventForm.value.title ||
            !eventForm.value.date ||
            teamArr.length == 0 ||
            !eventForm.value.delivary" (click)="onclickNext()">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
